var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5597_252938",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 2.25C6.75 2.67306 6.63324 3.06885 6.43019 3.4069C5.95269 3.64018 5.5348 3.97661 5.20553 4.38716C4.98362 4.46038 4.74644 4.5 4.5 4.5C3.25736 4.5 2.25 3.49264 2.25 2.25C2.25 1.00736 3.25736 0 4.5 0C5.74264 0 6.75 1.00736 6.75 2.25ZM5.75 2.25C5.75 2.94036 5.19036 3.5 4.5 3.5C3.80964 3.5 3.25 2.94036 3.25 2.25C3.25 1.55964 3.80964 1 4.5 1C5.19036 1 5.75 1.55964 5.75 2.25Z",
    fill: "#000001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57026 3.40764C10.0469 3.6408 10.4641 3.97678 10.793 4.38668C11.0153 4.46021 11.253 4.5 11.5 4.5C12.7426 4.5 13.75 3.49264 13.75 2.25C13.75 1.00736 12.7426 0 11.5 0C10.2574 0 9.25 1.00736 9.25 2.25C9.25 2.67337 9.36693 3.06943 9.57026 3.40764ZM11.5 3.5C12.1904 3.5 12.75 2.94036 12.75 2.25C12.75 1.55964 12.1904 1 11.5 1C10.8096 1 10.25 1.55964 10.25 2.25C10.25 2.94036 10.8096 3.5 11.5 3.5Z",
    fill: "#000001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51886 5.78573L4.5 5.78571C1.8 5.78571 0 6.99454 0 8.48571C0 9.47982 0.805888 10.2857 1.8 10.2857H4.90421C5.40616 10.1079 5.95439 9.97604 6.53925 9.89415C6.19574 9.74048 5.88087 9.53426 5.60488 9.28571H1.8C1.35817 9.28571 1 8.92753 1 8.48571C1 8.18708 1.1737 7.79294 1.76472 7.42625C2.34424 7.06668 3.24795 6.7973 4.42348 6.78607C4.42112 6.73268 4.41992 6.67899 4.41992 6.62501C4.41992 6.33597 4.45418 6.05493 4.51886 5.78573Z",
    fill: "#000001"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 10.2857H11.0947C10.5928 10.1079 10.0445 9.97604 9.45967 9.89415C9.80319 9.74048 10.1181 9.53426 10.394 9.28571H14.2C14.6418 9.28571 15 8.92753 15 8.48571C15 8.18708 14.8263 7.79294 14.2353 7.42625C13.6556 7.06657 12.7515 6.79713 11.5754 6.78606C11.5778 6.73267 11.579 6.67898 11.579 6.62501C11.579 6.33597 11.5447 6.05493 11.4801 5.78573L11.5 5.78571C14.2 5.78571 16 6.99454 16 8.48571C16 9.47982 15.1941 10.2857 14.2 10.2857Z",
    fill: "#000001"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.24999C9.44974 9.24999 10.625 8.07474 10.625 6.625C10.625 5.17525 9.44974 4 8 4C6.55025 4 5.375 5.17525 5.375 6.625C5.375 8.07474 6.55025 9.24999 8 9.24999ZM8 8.24999C8.89746 8.24999 9.62499 7.52246 9.62499 6.625C9.62499 5.72754 8.89746 5 8 5C7.10254 5 6.375 5.72754 6.375 6.625C6.375 7.52246 7.10254 8.24999 8 8.24999Z",
    fill: "#000001"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 10.75C4.85 10.75 2.75 12.1603 2.75 13.9C2.75 15.0598 3.6902 16 4.85 16H11.15C12.3098 16 13.25 15.0598 13.25 13.9C13.25 12.1603 11.15 10.75 7.99999 10.75ZM4.72096 12.5223C3.9987 12.9705 3.75 13.4771 3.75 13.9C3.75 14.5075 4.24249 15 4.85 15H11.15C11.7575 15 12.25 14.5075 12.25 13.9C12.25 13.4771 12.0013 12.9705 11.279 12.5223C10.5557 12.0736 9.43786 11.75 7.99999 11.75C6.56212 11.75 5.44425 12.0736 4.72096 12.5223Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5597_252938)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamOutlined);
export default __webpack_public_path__ + "static/media/team-outlined.0ce4fefa4c8705e9a9dee2e9434a4212.svg";
export { ForwardRef as ReactComponent };